/**
 * SPA-side OAuth callback. Only used if we end up routing the OAuth redirect
 * through the SPA instead of the Worker — kept here for safety + dev.
 *
 * In the production spike flow, Google redirects to the Worker
 * (`oauth-callback`), which serves its own self-contained HTML page that
 * handles the postMessage handshake. So this route should never be hit during
 * normal use; if it is, we just show a passthrough message.
 */
import { useEffect } from "react";

export function OAuthCallback() {
  useEffect(() => {
    // If Google for some reason redirects to the SPA, forward to the Worker
    // callback so the same exchange path runs.
    const params = window.location.search;
    const workerCallback =
      (import.meta.env as { VITE_OAUTH_WORKER_BASE?: string }).VITE_OAUTH_WORKER_BASE ??
      "http://localhost:8787";
    window.location.replace(`${workerCallback}/oauth/callback/google${params}`);
  }, []);

  return (
    <div className="flex h-full items-center justify-center p-8 text-slate-600">
      Redirecting to OAuth handler…
    </div>
  );
}
